import { mergeWithArrayOverride } from '@yimoka/shared';
import rawEnUS from 'antd/locale/en_US';

import { normalizeAntdLocale } from './normalize.js';

const enUS = normalizeAntdLocale(rawEnUS);

export default mergeWithArrayOverride({}, enUS, {
  Common: { confirm: 'Confirm', cancel: 'Cancel', submit: 'Submit', reset: 'Reset' },
  Exception: {
    backHome: 'Back home',
    retry: 'Try again',
    errorTitle: 'An error occurred',
    forbidden: 'Sorry, you are not authorized to access this page',
    notFound: 'Sorry, the page you visited does not exist',
    serverError: 'Sorry, the server encountered an error',
  },
  StoreTable: { total: total => `Total ${total} records`, itemsPerPage: '/ page' },
  UploadS3: { upload: 'Upload' },
  YimokaImage: { empty: 'No image' },
  InImage: {
    delete: 'Delete',
    inputAddress: 'Enter URL',
    viewAddress: 'View URL',
    inputTitle: 'Enter image URL',
    inputPlaceholder: 'Enter image URL',
    viewTitle: 'View image URL',
  },
  PrefixPhoneSelect: { placeholder: 'Enter phone number', countryNameField: 'english_name' },
  I18nEditor: {
    confirm: 'Confirm',
    title: 'Translations',
    help: 'Empty content uses the default field value. Remember to submit after confirming the content.',
    addLanguage: 'Add language',
    selectLanguage: 'Select a language',
    languageExists: 'This language already exists',
  },
});
